import * as ambassadorWixBookingsCalendarV2ExternalCalendar from './bookings-calendar-v2-external-calendar-external-calendars.http.js';
import * as ambassadorWixBookingsCalendarV2ExternalCalendarTypes from './bookings-calendar-v2-external-calendar-external-calendars.types.js';
import * as ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes from './bookings-calendar-v2-external-calendar-external-calendars.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listProviders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListProvidersRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListProvidersRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListProvidersResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListProvidersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.listProviders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/external-calendars/providers',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getConnection(): __PublicMethodMetaInfo<
  'GET',
  { connectionId: string },
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.GetConnectionRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.GetConnectionRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.GetConnectionResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.GetConnectionResponse
> {
  const payload = { connectionId: ':connectionId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.getConnection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/external-calendars/connections/{connectionId}',
    pathParams: { connectionId: 'connectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listConnections(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListConnectionsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListConnectionsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListConnectionsResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListConnectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.listConnections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/external-calendars/connections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function connectByOAuth(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ConnectByOAuthRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ConnectByOAuthRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ConnectByOAuthResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ConnectByOAuthResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.connectByOAuth(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/external-calendars/connections:connectByOAuth',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function connectByCredentials(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ConnectByCredentialsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ConnectByCredentialsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ConnectByCredentialsResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ConnectByCredentialsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.connectByCredentials(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/external-calendars/connections:connectByCredentials',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCalendars(): __PublicMethodMetaInfo<
  'GET',
  { connectionId: string },
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListCalendarsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListCalendarsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListCalendarsResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListCalendarsResponse
> {
  const payload = { connectionId: ':connectionId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.listCalendars(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/external-calendars/connections/{connectionId}/calendars',
    pathParams: { connectionId: 'connectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSyncConfig(): __PublicMethodMetaInfo<
  'PATCH',
  { connectionId: string },
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.UpdateSyncConfigRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.UpdateSyncConfigRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.UpdateSyncConfigResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.UpdateSyncConfigResponse
> {
  const payload = { connectionId: ':connectionId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.updateSyncConfig(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/external-calendars/connections/{connectionId}/sync-config',
    pathParams: { connectionId: 'connectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function disconnect(): __PublicMethodMetaInfo<
  'POST',
  { connectionId: string },
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.DisconnectRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.DisconnectRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.DisconnectResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.DisconnectResponse
> {
  const payload = { connectionId: ':connectionId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.disconnect(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/external-calendars/connections/{connectionId}/disconnect',
    pathParams: { connectionId: 'connectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listEvents(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListEventsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListEventsRequest,
  ambassadorWixBookingsCalendarV2ExternalCalendarUniversalTypes.ListEventsResponse,
  ambassadorWixBookingsCalendarV2ExternalCalendarTypes.ListEventsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsCalendarV2ExternalCalendar.listEvents(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/external-calendars/events',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ExternalCalendar as ExternalCalendarOriginal,
  ListProvidersRequest as ListProvidersRequestOriginal,
  ListProvidersResponse as ListProvidersResponseOriginal,
  Provider as ProviderOriginal,
  CalendarType as CalendarTypeOriginal,
  CalendarTypeWithLiterals as CalendarTypeWithLiteralsOriginal,
  ProviderFeatures as ProviderFeaturesOriginal,
  ConnectMethod as ConnectMethodOriginal,
  ConnectMethodWithLiterals as ConnectMethodWithLiteralsOriginal,
  ListEventFromCalendars as ListEventFromCalendarsOriginal,
  ListEventFromCalendarsWithLiterals as ListEventFromCalendarsWithLiteralsOriginal,
  SyncToCalendar as SyncToCalendarOriginal,
  SyncToCalendarWithLiterals as SyncToCalendarWithLiteralsOriginal,
  GetConnectionRequest as GetConnectionRequestOriginal,
  GetConnectionResponse as GetConnectionResponseOriginal,
  Connection as ConnectionOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ErrorReason as ErrorReasonOriginal,
  ErrorReasonWithLiterals as ErrorReasonWithLiteralsOriginal,
  ConnectionSyncConfig as ConnectionSyncConfigOriginal,
  Calendar as CalendarOriginal,
  PrimaryCalendar as PrimaryCalendarOriginal,
  Calendars as CalendarsOriginal,
  DedicatedCalendar as DedicatedCalendarOriginal,
  ConnectionSyncConfigListEventFromCalendars as ConnectionSyncConfigListEventFromCalendarsOriginal,
  ConnectionSyncConfigListEventFromCalendarsListFromOneOf as ConnectionSyncConfigListEventFromCalendarsListFromOneOfOriginal,
  ConnectionSyncConfigSyncToCalendar as ConnectionSyncConfigSyncToCalendarOriginal,
  ConnectionSyncConfigSyncToCalendarSyncToOneOf as ConnectionSyncConfigSyncToCalendarSyncToOneOfOriginal,
  SyncToErrorReason as SyncToErrorReasonOriginal,
  SyncToErrorReasonWithLiterals as SyncToErrorReasonWithLiteralsOriginal,
  ListConnectionsRequest as ListConnectionsRequestOriginal,
  ListConnectionsResponse as ListConnectionsResponseOriginal,
  ConnectByOAuthRequest as ConnectByOAuthRequestOriginal,
  ConnectByOAuthResponse as ConnectByOAuthResponseOriginal,
  RawHttpRequest as RawHttpRequestOriginal,
  PathParametersEntry as PathParametersEntryOriginal,
  QueryParametersEntry as QueryParametersEntryOriginal,
  HeadersEntry as HeadersEntryOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  ConnectByCredentialsRequest as ConnectByCredentialsRequestOriginal,
  ConnectByCredentialsResponse as ConnectByCredentialsResponseOriginal,
  ListCalendarsRequest as ListCalendarsRequestOriginal,
  ListCalendarsResponse as ListCalendarsResponseOriginal,
  UpdateSyncConfigRequest as UpdateSyncConfigRequestOriginal,
  UpdateSyncConfigResponse as UpdateSyncConfigResponseOriginal,
  DisconnectRequest as DisconnectRequestOriginal,
  DisconnectResponse as DisconnectResponseOriginal,
  ListEventsRequest as ListEventsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListEventsResponse as ListEventsResponseOriginal,
  Event as EventOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ScheduleNotification as ScheduleNotificationOriginal,
  ScheduleNotificationEventOneOf as ScheduleNotificationEventOneOfOriginal,
  ScheduleCreated as ScheduleCreatedOriginal,
  Schedule as ScheduleOriginal,
  RecurringInterval as RecurringIntervalOriginal,
  Interval as IntervalOriginal,
  Day as DayOriginal,
  DayWithLiterals as DayWithLiteralsOriginal,
  Frequency as FrequencyOriginal,
  LinkedSchedule as LinkedScheduleOriginal,
  Transparency as TransparencyOriginal,
  TransparencyWithLiterals as TransparencyWithLiteralsOriginal,
  RecurringIntervalType as RecurringIntervalTypeOriginal,
  RecurringIntervalTypeWithLiterals as RecurringIntervalTypeWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  LocationsLocation as LocationsLocationOriginal,
  LocationStatus as LocationStatusOriginal,
  LocationStatusWithLiterals as LocationStatusWithLiteralsOriginal,
  LocationsLocationType as LocationsLocationTypeOriginal,
  LocationsLocationTypeWithLiterals as LocationsLocationTypeWithLiteralsOriginal,
  LocationsAddress as LocationsAddressOriginal,
  LocationsStreetAddress as LocationsStreetAddressOriginal,
  LocationsAddressLocation as LocationsAddressLocationOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Rate as RateOriginal,
  Price as PriceOriginal,
  Availability as AvailabilityOriginal,
  AvailabilityConstraints as AvailabilityConstraintsOriginal,
  SplitInterval as SplitIntervalOriginal,
  Participant as ParticipantOriginal,
  ApprovalStatus as ApprovalStatusOriginal,
  ApprovalStatusWithLiterals as ApprovalStatusWithLiteralsOriginal,
  ExternalCalendarOverrides as ExternalCalendarOverridesOriginal,
  ScheduleStatus as ScheduleStatusOriginal,
  ScheduleStatusWithLiterals as ScheduleStatusWithLiteralsOriginal,
  Version as VersionOriginal,
  ConferenceProvider as ConferenceProviderOriginal,
  CalendarConference as CalendarConferenceOriginal,
  ConferenceType as ConferenceTypeOriginal,
  ConferenceTypeWithLiterals as ConferenceTypeWithLiteralsOriginal,
  ScheduleUpdated as ScheduleUpdatedOriginal,
  RecurringSessionsUpdated as RecurringSessionsUpdatedOriginal,
  Session as SessionOriginal,
  CalendarDateTime as CalendarDateTimeOriginal,
  LocalDateTime as LocalDateTimeOriginal,
  ExternalCalendarInfo as ExternalCalendarInfoOriginal,
  SessionStatus as SessionStatusOriginal,
  SessionStatusWithLiterals as SessionStatusWithLiteralsOriginal,
  SessionType as SessionTypeOriginal,
  SessionTypeWithLiterals as SessionTypeWithLiteralsOriginal,
  SessionVersion as SessionVersionOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  ScheduleCancelled as ScheduleCancelledOriginal,
  SessionCreated as SessionCreatedOriginal,
  SessionUpdated as SessionUpdatedOriginal,
  SessionCancelled as SessionCancelledOriginal,
  AvailabilityPolicyUpdated as AvailabilityPolicyUpdatedOriginal,
  AvailabilityPolicy as AvailabilityPolicyOriginal,
  IntervalSplit as IntervalSplitOriginal,
  RecurringSessionSplit as RecurringSessionSplitOriginal,
  ScheduleUnassignedFromUser as ScheduleUnassignedFromUserOriginal,
  MultipleSessionsCreated as MultipleSessionsCreatedOriginal,
  ScheduleWithSessions as ScheduleWithSessionsOriginal,
  SitePropertiesOnScheduleCreation as SitePropertiesOnScheduleCreationOriginal,
  MigrationEvent as MigrationEventOriginal,
  MigrationData as MigrationDataOriginal,
  StaffData as StaffDataOriginal,
  Empty as EmptyOriginal,
  ConnectByOAuthApplicationErrors as ConnectByOAuthApplicationErrorsOriginal,
  ConnectByCredentialsApplicationErrors as ConnectByCredentialsApplicationErrorsOriginal,
  ListCalendarsApplicationErrors as ListCalendarsApplicationErrorsOriginal,
  UpdateSyncConfigApplicationErrors as UpdateSyncConfigApplicationErrorsOriginal,
  DisconnectApplicationErrors as DisconnectApplicationErrorsOriginal,
} from './bookings-calendar-v2-external-calendar-external-calendars.types.js';
